import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { checkIfExternalAbsoluteUrl } from 'components/hf/HFLink';
import { isLeftClickEvent, isModifiedEvent } from 'helpers/EventHelpers';
import useMartyContext from 'hooks/useMartyContext';

interface Props {
  children?: ReactNode;
  className?: string;
  target?: string;
  to: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => any;
  [key: string]: any;
}

export const MartyLink = (props: Props) => {
  const { onClick, to = '', ...rest } = props;

  const { router } = useMartyContext();

  const isExternal = checkIfExternalAbsoluteUrl(to, props.origin);
  if (isExternal) {
    const { innerRef, forwardRef, children, ...externalRest } = rest;
    return (
      <a ref={innerRef || forwardRef} href={to} onClick={onClick} {...externalRest}>
        {children}
      </a>
    );
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const { target, to = '' } = props;

    if (onClick) {
      onClick(e);
    }

    if (!isLeftClickEvent(e) || isModifiedEvent(e) || e.defaultPrevented || target) {
      return;
    }

    e.preventDefault();
    router.pushPreserveAppRoot(to);
  };

  return <Link to={to} onClick={handleClick} {...rest} />;
};

export default MartyLink;
